import React from 'react';
import './footer.css';
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container container">
        <h1 className="footer__title">Amaresh Barik</h1>
        <div className="footer__social">
          <a
            href="https://www.gmail.com"
            className="footer__social-icon"
            target="_blank"
            rel="noreferrer"
          >
            <i className="bx bxl-gmail"></i>
          </a>
          <a
            href="https://github.com/amareshcoding"
            className="footer__social-icon"
            target="_blank"
            rel="noreferrer"
          >
            <i className="bx bxl-github"></i>
          </a>
          <a
            href="https://www.linkedin.com/in/amareshbarik/"
            className="footer__social-icon"
            target="_blank"
            rel="noreferrer"
          >
            <i className="bx bxl-linkedin"></i>
          </a>
        </div>
        <span className="footer__copy">2022 &#169; Amaresh. All right reserved</span>
      </div>
    </footer>
  );
};

export default Footer;
